import React, { cloneElement, ReactElement } from "react";
import Box, { BoxProps } from "../box/Box";
import Input, { getInputSizesProps, IInput } from "./Input";
import { InputLeftElement, InputRightElement } from "./InputElement";
import { useTheme } from "../theme/ThemeProvider";
import { cleanChildren } from "../utils";

export interface IInputGroup {
  size?: IInput["size"];
  children: ReactElement[];
}

export type InputGroupProps = IInputGroup & BoxProps;

const InputGroup: React.FC<InputGroupProps> = ({ children, size = "md", ...props }) => {
  const { sizes } = useTheme();
  const { height } = getInputSizesProps(size);
  let pl: number | null = null;
  let pr: number | null = null;

  const validChildren = cleanChildren(children);

  return (
    <Box display="flex" position="relative" {...props}>
      {validChildren.map((child: any) => {
        if (child.type === InputLeftElement) {
          // @ts-ignore
          pl = sizes[height];
        }
        if (child.type === InputRightElement) {
          // @ts-ignore
          pr = sizes[height];
        }
        if (child.type === Input) {
          return cloneElement(child as any, {
            size,
            pl: (child as any).props.pl || pl,
            pr: (child as any).props.pr || pr,
          });
        }
        return cloneElement(child, { size });
      })}
    </Box>
  );
};

export default InputGroup;
